/* eslint-disable no-console */
import React, { useRef, useState } from 'react';
import { Box, Stack, Title, Button, Grid, Center, Image, Input, Space, Text } from '@mantine/core';
import { NotificationsProvider } from '@mantine/notifications';
import { useForm } from '@mantine/form';

import { useNavigate, createSearchParams } from 'react-router-dom';
import Keyboard from 'react-simple-keyboard';
import BasicLayout from '../../components/BasicLayout';
import 'react-simple-keyboard/build/css/index.css';
import logo from '../../image/mouqfi.png';

import CountryCodeSelect from '../../components/CountryCodeSelect/CountryCodeSelect';

const Login = () => {
  const navigate = useNavigate();
  const [layout, setLayout] = useState('default');
  const keyboard = useRef();
  const [inputData, setInputData] = useState('');
  const [shiftButtonText, setShiftButtonText] = useState('Arabic');

  const [touched, setTouched] = useState(false);

  const form = useForm({
    validateInputOnChange: true,
    initialValues: {
      country_code_id: 194,
    },
  });

  console.log('lll', localStorage.getItem('token'));
  const generateOtp = (values) => {
    navigate({
      pathname: '/verify',
      search: createSearchParams({
        mobile: inputData,
        countryCode: values?.country_code_id,
      }).toString(),
    });
  };

  const onChangeInputNumber = (event) => {
    const data = event.target.value;
    setInputData(data);
    setTouched(true);
    keyboard.current.setInputData(data);
  };

  const onChangeNumber = (inputValue) => {
    setInputData(inputValue);
    setTouched(true);
  };

  const handleShift = () => {
    const newLayoutName = layout === 'default' ? 'shift' : 'default';
    setLayout(newLayoutName);
    if (shiftButtonText === 'Arabic') {
      setShiftButtonText('English');
    } else if (shiftButtonText === 'English') {
      setShiftButtonText('Arabic');
    }
  };

  const onKeyPress = (button) => {
    /**
     * If you want to handle the shift and caps lock buttons
     */
    if (button === '{shift}' || button === '{lock}') handleShift();
  };

  const showError = touched && (inputData.length < 7 || inputData.length > 12);

  return (
    <BasicLayout>
      <NotificationsProvider position="bottom-center">
        <Box>
          <Grid>
            <Grid.Col span={6} offset={3}>
              <Box
                sx={(theme) => ({
                  backgroundColor:
                    theme.colorScheme === 'dark' ? theme.colors.dark[6] : theme.colors.gray[0],
                  padding: theme.spacing.xl,
                  borderRadius: theme.radius.md,
                })}
              >
                <Center>
                  <Image radius="md" src={logo} alt="Random unsplash image" width="130px" />
                </Center>

                <Center py="xl">
                  <Title order={3}>Login by OTP</Title>
                </Center>

                <form onSubmit={form.onSubmit((values) => generateOtp(values))}>
                  <Stack size="xs">
                    <CountryCodeSelect
                      required
                      label="Country Code"
                      autoComplete="country Code"
                      {...form.getInputProps('country_code_id')}
                    />

                    <Input.Wrapper label="Phone Number" required>
                      <Input
                        type="number"
                        placeholder="Enter Phone Number"
                        {...form.getInputProps('number')}
                        value={inputData}
                        onChange={onChangeInputNumber}
                        maxLength={12}
                        minLength={7}
                      />
                      {showError && (
                        <Text fz="xs" color="red">
                          Mobile Number min 7 and max 12
                        </Text>
                      )}
                    </Input.Wrapper>
                  </Stack>
                  <Center py="lg">
                    <Button type="submit">Send OTP</Button>
                  </Center>
                </form>
              </Box>

              <Space h="xl" />

              <Keyboard
                keyboardRef={(r) => {
                  keyboard.current = r;
                }}
                onChange={onChangeNumber}
                onKeyPress={onKeyPress}
                layoutName={layout}
                maxLength={12}
                theme="hg-theme-default hg-layout-default myTheme enable-button"
                layout={{
                  default: ['1 2 3 4 5 6 7 8 9 0 {bksp}'],
                  shift: ['1 2 3', '4 5 6', '7 8 9', ' 0 {bksp}'],
                }}
                display={{
                  '{bksp}': '⌫',
                  '{enter}': 'Enter',
                }}
              />

              <Space h="xl" />
            </Grid.Col>
          </Grid>
        </Box>
      </NotificationsProvider>
    </BasicLayout>
  );
};

export default Login;
